import Yup from '../yup';
import _ from 'lodash';

const applicationType = {
  app_types: Yup.array()
    .ensure()
    .min(1, 'Please select an option to proceed'),
};

export default applicationType;
